import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CalendarDaysIcon, ClockIcon } from '@heroicons/react/24/outline';

const ManageViewingsQuickAction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate('/landlord-toolkit/manage-viewings')}
      className="w-full group flex items-center justify-between p-4 sm:p-6 bg-white border border-gray-200 rounded-xl sm:rounded-2xl shadow-sm hover:shadow-md hover:border-purple-500 transition-all duration-200 text-left"
    >
      <div className="flex items-center gap-4 sm:gap-5">
        <div className="p-3 sm:p-4 bg-purple-50 text-purple-600 rounded-lg sm:rounded-xl group-hover:bg-purple-100 transition-colors">
          <CalendarDaysIcon className="w-6 h-6 sm:w-8 sm:h-8" />
        </div>
        <div>
          <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-1">Manage Viewings</h3>
          <p className="text-gray-500 text-sm sm:text-base leading-snug sm:leading-relaxed">
            Schedule slots, manage bookings, and track attendees.
          </p>
        </div>
      </div>
      <div className="hidden sm:flex bg-purple-600 text-white rounded-full p-2 ml-4 group-hover:bg-purple-700 transition-colors">
        <ClockIcon className="w-6 h-6" />
      </div>
    </button>
  );
};

export default ManageViewingsQuickAction;
